<template>
  <div class="assinatura-page">
    <Topo @selecionar-assinatura="selecionarAssinatura" />
    <div class="row">
      <div class="col-md-4 mt-3">
        <Menu />
      </div>
      <!-- Conteudo das views -->
      <div class="col-md-8 mt-3">

        <MensagemAssinaturaNaoDisponivel :subscription="subscription" />

        <div
          v-if="!loading && subscription != null && (subscription.paymentType == 'DEBIT_CARD' || subscription.paymentType == 'CREDIT_CARD') && creditcard == null && subscription.status == 'OK'"
          class="alert alert-danger">
          <strong>
            ATENÇÃO
          </strong>
          sua forma de pagamento é Débito ou Crédito e você ainda não inseriu seu cartão.
          Evite o bloqueio da sua assinatura.
          <a href="#" @click="openModalChangeCreditCard" class="card-link link-padrao">Inserir Cartão Agora</a>.
        </div>

        <!-- assinatura -->
        <div class="card" v-if="subscription != null">
          <div class="card-body">
            <h5 class="card-title mb-4">Assinatura e Cobrança</h5>
            <h6 class="card-subtitle mb-4">Situação:
              <strong v-if="subscription.status == 'BLOCKED'">BLOQUEADA<br /></strong>
              <h6 v-if="subscription.status == 'BLOCKED' && subscription.dateBlocked != null">Bloqueada em {{
                subscription.dateBlocked }} </h6>
              <strong v-if="subscription.status == 'BLOCKED' && subscription.waitingFirstPay"> - Aguardando Pagamento do
                Cliente</strong>
              <strong v-if="subscription.status == 'OK'">ATIVA</strong>
              <strong v-if="subscription.status == 'CANCELED'">CANCELADA</strong>
              <strong v-if="subscription.status == 'OUT_OF_DATE'">FORA DE VIGÊNCIA / CANCELADA</strong>
              <strong v-if="subscription.status == 'REQUESTED_CARD'">BLOQUEADA</strong>
            </h6>
            <p class="card-subtitle mb-2">Plano: <strong>{{subscription.plan.siteName ? subscription.plan.siteName :
                subscription.plan.name}} </strong></p>
            <p class="card-subtitle mb-2">Data da assinatura: <strong>{{subscription.dateBegin}}</strong></p>
            <p class="card-subtitle mb-2">Possui Fidelidade: <strong>{{subscription.plan.hasfidelity ? 'Sim' : 'Não'}}
              </strong></p>
            <p class="card-subtitle mb-2">Dia de Vencimento: <strong>{{subscription.dayForPayment}}</strong> <a href="#"
                v-show="subscription.status == 'OK'" @click="openModalChangeDueDate"
                class="card-link link-padrao ml-1">(Modificar)</a></p>
            <p class="card-subtitle mb-2">Valor: <strong>{{subscription.totalPriceFmt}} mensais</strong></p>
            <p class="card-subtitle mb-2">Forma de Pagamento:
              <strong v-if="subscription.paymentType == 'TICKETS'">Carnê <a href="#"
                  v-if="subscription.typeSub == 'PF' && subscription.status == 'OK'" @click="openModalChangePaymentType"
                  class="btn btn-danger btn-sm ml-2">Mudar para Cartão</a></strong>
              <strong v-if="subscription.paymentType == 'TICKET'">Boleto Bancário <a href="#"
                  v-if="subscription.typeSub == 'PF' && subscription.status == 'OK'" @click="openModalChangePaymentType"
                  class="btn btn-danger btn-sm ml-2">Mudar para Cartão</a></strong>
              <strong v-if="subscription.paymentType == 'DEBIT_CARD'">Cartão de Débito</strong>
              <strong v-if="subscription.paymentType == 'CREDIT_CARD'">Cartão de Crédito</strong>
              <strong v-if="subscription.paymentType == 'AUTOMATIC_PIX'">Pix automático</strong>
            </p>
            <!-- <a href="#" v-if="(subscription.paymentType == 'DEBIT_CARD' || subscription.paymentType == 'CREDIT_CARD') && subscription.typeSub == 'PF'" @click="openModalChangePaymentType" class="card-link link-padrao">Alterar Forma de Pagamento</a> -->

            <p class="mt-3">Em caso de solicitação de cancelamento, entre em contato pelos canais oficiais.</p>
          </div>
        </div>

        <!-- cartoes -->
        <div class="card mt-3"
          v-if="subscription != null && (subscription.paymentType == 'CREDIT_CARD' || subscription.paymentType == 'DEBIT_CARD')">
          <div class="card-body"
            v-if="subscription != null && creditcard == null && (subscription.paymentType == 'CREDIT_CARD' || subscription.paymentType == 'DEBIT_CARD')">
            <h5 class="card-title mb-4">Cartão de Crédito/Débito</h5>
            <a href="#" @click="openModalChangeCreditCard" class="card-link link-padrao">Incluir Cartão de Crédito</a>
          </div>
          <div class="card-body"
            v-if="subscription != null && creditcard != null && (subscription.paymentType == 'CREDIT_CARD' || subscription.paymentType == 'DEBIT_CARD')">
            <h5 class="card-title mb-4">Cartão de Crédito/Débito</h5>
            <p class="card-subtitle mb-2">Bandeira: <i
                :class="'mr-2 ml-1 fab fa-cc-' + creditcard.brand.toLowerCase()"></i> <strong>{{creditcard.brand}}
              </strong></p>
            <p class="card-subtitle mb-2">Final: <strong>{{creditcard.finalNumbers}}</strong></p>
            <a href="#" @click="openModalChangeCreditCard" class="card-link link-padrao">Atualizar Cartão de Crédito</a>
          </div>
        </div>

        <!-- beneficiario -->
        <div class="card mt-3 mb-4" v-show="subscription != null && subscription.typeSub == 'PJ'">
          <div class="card-body">
            <h5 class="card-title mb-4">Beneficiários</h5>
            <div class="row col-md-12 text-left mb-2">
              <a href="#" class="btn btn-primary" @click="openModalAddDependent">Incluir Beneficiário</a>
            </div>
            <table class="table table-responsive">
              <tbody>
                <tr v-for="life in lifes" :key="life.holder.id">
                  <td>{{life.holder.name}} <br> (CPF: {{life.holder.cpfCnpjFmt}})</td>
                  <td>
                    <table class="table table-responsive font-tabela-peq">
                      <thead class="thead">
                        <tr>
                          <th scope="col">Nome</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Cartão</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="card in life.cards" :key="card.token">
                          <td>
                            <span v-if="card.isCardOfHolder">{{card.holder.name}}</span>
                            <span v-else>{{card.dependent.name}}</span>
                          </td>
                          <td>
                            <span v-if="card.isCardOfHolder">Titular</span>
                            <span v-else>Dependente</span>
                          </td>
                          <td>
                            {{card.numberOnCard}}
                          </td>
                          <td>
                            <span v-show="card.status == 'BLOCKED'"> BLOQUEADO</span>
                            <span v-show="card.status == 'OK'">ATIVO</span>
                            <span v-show="card.status == 'CANCELED'">
                              CANCELADO<br>
                              (Em {{card.dateCancel}})
                            </span>
                            <span v-show="card.status == 'EXPIRED'">EXPIRADO</span>
                            <span v-show="card.status == 'BLOCKED_BY_FRAUD'">BLOQUEADO POR FRAUDE</span>
                          </td>
                        </tr>
                        <tr v-show="lifes == null">
                          <td>
                            Nenhum titular disponível.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-show="lifes == null">
                  <td>
                    Nenhum beneficiário disponível.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- dependentes -->
        <div class="card mt-3 mb-4" v-show="subscription != null && subscription.typeSub == 'PF'">
          <div class="card-body">
            <h5 class="card-title mb-4">Dependentes</h5>
            <div class="row col-md-12 text-left mb-2" v-show="subscription.status == 'OK'">
              <a href="#" class="btn btn-primary" @click="openModalAddDependent">Incluir Dependente</a>
            </div>
            <table class="table table-responsive">
              <thead class="thead-light">
                <tr>
                  <th scope="col">Nome</th>
                  <th scope="col">Nascimento</th>
                  <th scope="col">Status</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dependent in dependents" :key="dependent.id">
                  <th scope="row">{{dependent.name}}</th>
                  <td>{{dependent.dateOfBirth}}</td>
                  <td>
                    <span v-show="dependent.status == 'OK' && dependent.dateOfRemoval == null">Ativo</span>
                    <span v-show="dependent.status == 'OK' && dependent.dateOfRemoval != null">Ativo até
                      <strong>{{dependent.dateOfRemoval}}</strong></span>
                    <span v-show="dependent.status == 'REMOVED'">Cancelado em
                      <strong>{{dependent.dateOfRemoval}}</strong></span>
                  </td>
                  <!-- td>
                                                          <a href="#" v-show="dependent.status == 'OK' && dependent.dateOfRemoval == null" class="link-padrao" @click="cancelDependent(dependent)">Cancelar</a>
                                                      </td -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

    <!-- Modais -->
    <modal name="modal-alterar-vencimento" width="300px">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Alterar Vencimento</h4>
        <p class="mt-1 text-center">A alteração terá efeito nas faturas pendentes de pagamento.</p>
        <select class="form-control" v-model="newpaymentday">
          <option value="5">Dia 5</option>
          <option value="10">Dia 10</option>
          <option value="15">Dia 15</option>
          <option value="20">Dia 20</option>
          <option value="25">Dia 25</option>
        </select>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="updatePayDay">Confirmar</button>
          <button type="button" class="btn btn-secundary ml-4" @click="closeModalChangeDueDate">Desistir</button>
        </div>
      </form>
    </modal>

    <modal name="modal-cadastrar-cartao" width="400px" height="auto" :scrollable="true">
      <form class="ml-3 mt-3 mr-3 mb-3" @submit.prevent="addCreditCard">
        <h4 class="text-center mb-4">Novo Cartão</h4>

        <div class="form-group">
          <label for="cardName">Nome no Cartão</label>
          <input type="text" id="cardName" class="form-control" v-model="newcreditcard.name"
            placeholder="Nome como está no cartão" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="far fa-credit-card"></i></span>
          </div>
          <input type="text" class="form-control mb-2" v-model="newcreditcard.number" placeholder="Número do Cartão"
            v-mask="['####.####.####.####']" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
          </div>
          <input type="text" class="form-control mb-2" v-model="newcreditcard.validate" placeholder="Vencimento Mês/Ano"
            v-mask="['##/##', '##/####']" />
        </div>
        <div class="input-group">
          <div class="input-group-prepend mb-2">
            <span class="input-group-text"><i class="fas fa-key"></i></span>
          </div>
          <input type="text" class="form-control mb-2" v-model="newcreditcard.securityCode"
            placeholder="Código de Segurança" v-mask="['####']" />
        </div>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="updateCreditCard">Confirmar</button>
          <button type="button" class="btn btn-secundary ml-4" @click="closeModalChangeCreditCard">Desistir</button>
        </div>
      </form>
    </modal>

    <modal name="modal-alterar-formapgt" width="300px">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Alterar Forma de Pagamento</h4>
        <p class="mt-1 text-center">A alteração terá efeito na próxima fatura.</p>
        <select class="form-control" v-model="newpaymenttype">
          <option value="CREDIT_CARD">Cartão de Crédito</option>
          <!-- <option value="DEBIT_CARD">Cartão de Débito</option> -->
        </select>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="preparePaymentType">Confirmar</button>
          <button type="button" class="btn btn-secundary ml-4" @click="closeModalChangePaymentType">Desistir</button>
        </div>
      </form>
    </modal>

    <modal name="modal-add-dependente" height="auto" :scrollable="true">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Inclusão de Dependente</h4>
        <p class="mt-1 text-center">Uma fatura de pagamento será gerada separadamente, para os dependentes inclusos.</p>
        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="(dep, index) in addDependentForm.dependents" :key="dep.cpf">
            {{dep.name}}
            <button type="button" class="btn btn-light ml-2"
              @click="addDependentForm.dependents.splice(index, 1)">Remover</button>
          </li>
        </ul>
        <form class="mt-2">
          <div class="col-md-12 mb-2" v-if="subscription.typeSub == 'PJ'">
            <select class="form-control" v-model="newdependent.type">
              <option value="HOLDER">Titular</option>
              <option value="DEPENDENT">Dependente</option>
            </select>
          </div>
          <div class="col-md-12 mb-2">
            <input type="text" class="form-control" v-model="newdependent.name" placeholder="Nome *" maxlength="50" />
          </div>
          <div class="col-md-12 mb-2">
            <input type="text" class="form-control" v-model="newdependent.cpf" placeholder="CPF"
              v-mask="['###.###.###-##']" />
          </div>
          <div class="col-md-12 mb-2">
            <input type="text" class="form-control" v-model="newdependent.email" placeholder="E-mail" />
          </div>
          <div class="col-md-12 mb-2">
            <input type="text" class="form-control" v-model="newdependent.phone" placeholder="Telefone"
              v-mask="['(##)#####-####']" />
          </div>
          <div class="col-md-12 mb-2">
            <input type="text" class="form-control" v-model="newdependent.dateOfBirth" placeholder="Nascimento *"
              v-mask="['##/##/####']" />
          </div>
          <div class="col-md-12 mb-2">
            <select class="form-control" v-model="newdependent.sex">
              <option value="MALE">Masculino</option>
              <option value="FEMALE">Feminino</option>
              <option value="NI">Não informado</option>
            </select>
          </div>

          <div class="col-md-12 mb-2" v-if="subscription.typeSub == 'PF'">
            <select class="form-control mb-1" v-model="newdependent.kinship">
              <option value="">Parentesco</option>
              <option value="Pai">Pai</option>
              <option value="Mãe">Mãe</option>
              <option value="Avô">Avô</option>
              <option value="Avó">Avó</option>
              <option value="Filho/Filha">Filho/Filha</option>
              <option value="Tio/Tia">Tio/Tia</option>
              <option value="Irmão/Irmã">Irmão/Irmã</option>
              <option value="Sobrinho">Sobrinho</option>
              <option value="Neto">Neto</option>
              <option value="O">Outros</option>
            </select>
            <div class="input-group" v-if="newdependent.kinship=='O'">
              <div class="input-group-prepend mb-2">
                <span class="input-group-text"><i class="fas fa-user-plus"></i></span>
              </div>
              <input type="text" class="form-control mb-1" v-model="newdependent.kinshipAlt" placeholder="Outros"
                maxlength="30" />
            </div>
          </div>

          <div class="col-md-12 mb-2" v-if="subscription.typeSub == 'PJ' && newdependent.type == 'DEPENDENT'">
            <input type="text" class="form-control" v-model="newdependent.cpfHolder" placeholder="CPF do Titular *"
              v-mask="['###.###.###-##']" />
          </div>
          <div class="col-md-12 mb-2 text-center" v-if="subscription.typeSub != 'PJ'">
            <button type="button" class="btn btn-danger" @click="addDependent">Adicionar</button>
          </div>
        </form>
        <br class="clear" />
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-primary" @click="confirmAddDependent">Confirmar</button>
          <button type="button" class="btn btn-secundary ml-4" @click="closeModalAddDependent">Desistir</button>
        </div>
      </form>
    </modal>
    <Rodape />
  </div>
</template>

  <script>
import Topo from '@/components/Topo.vue'
import Rodape from '@/components/Rodape.vue'
import Menu from '@/components/Menu.vue'
import MensagemAssinaturaNaoDisponivel from '@/components/MensagemAssinaturaNaoDisponivel.vue'
import Vue from 'vue';
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: "6LeDu_IpAAAAAGawg8nR3SFA_ZYpSwsC71Ub1f_U" });

const optionsAlert = { title: 'Mensagem', size: 'sm' }

export default {
  name: 'assinatura',
  components: {
    Topo, Menu, MensagemAssinaturaNaoDisponivel, Rodape
  },
  data() {
    return {
      loading: false,
      lifes: [],
      changingPaymentType: false,
      addDependentForm: {
        dependents: [],
      },
      newdependent: {
        name: '',
        cpf: '',
        dateOfBirth: '',
        email: '',
        phone: '',
        sex: 'MALE',
        kinship: '',
        kinshipAlt: "",
      },
      newpaymenttype: null,
      newpaymentday: 5,
      newcreditcard: {
        name: null,
        number: null,
        validate: null,
        securityCode: null,
        brand: null,
        id: null,
      },
      subscription: { typeSub: null, paymentType: null, plan: { name: null } },
      dependents: null,
      creditcard: null,
      selecionadaSubscription: 0
    }
  },
  methods: {
    addDependent() {
      let kinshipPreenchido = this.newdependent.kinship;
      if (this.newdependent.kinship === "O") {
        kinshipPreenchido = this.newdependent.kinshipAlt;
      }
      this.addDependentForm.dependents.push({
        name: this.newdependent.name,
        cpf: this.newdependent.cpf,
        dateOfBirth: this.newdependent.dateOfBirth,
        email: this.newdependent.email,
        phone: this.newdependent.phone,
        sex: this.newdependent.sex,
        type: this.newdependent.type,
        cpfHolder: this.newdependent.cpfHolder,
        kinship: kinshipPreenchido
      })
      this.newdependent = {
        name: '',
        cpf: '',
        dateOfBirth: '',
        email: '',
        phone: '',
        sex: 'MALE',
        type: 'DEPENDENT',
        cpfHolder: null,
        kinship: '',
        kinshipAlt: "",
      }
    },
    confirmAddDependent() {
      this.closeModalAddDependent()
      const options = { title: 'Confirma inclusão', okLabel: 'Sim', cancelLabel: 'Não' }
      var mensagem = "Deseja realmente incluir o(s) dependente(s)? ";
      if (this.subscription.paymentType == 'TICKETS' && this.subscription.typeSub == 'PF') {
        mensagem += "Atenção: um novo carnê será gerado, e o seu carnê atual será cancelado.";
      } else if (this.subscription.paymentType == 'TICKET' && this.subscription.typeSub == 'PF') {
        mensagem += "Atenção: será gerado um boleto referente a assinatura do dependente para o mês atual.";
      } else if (this.subscription.typeSub == 'PF') {
        mensagem += "Atenção: será debitado no seu cartão o valor referente a assinatura do dependente para o mês atual.";
      } else if (this.subscription.typeSub == 'PJ') {
        mensagem += "Atenção: os valores serão cobrados na próxima fatura do cliente.";
      }
      this.$dialogs.confirm(mensagem, options)
        .then(res => {
          if (res.ok) {
            //verificar se o usuario esqueceu de clicar no botao de adicionar, fazer isso pra ele
            if (this.addDependentForm.dependents.length == 0) {
              this.addDependent()
            }
            this.$clubApi.post(`/subscriptions/${this.subscription.id}/dependents`, this.addDependentForm)
              .then(() => {
                if (this.subscription.paymentType == 'TICKETS' && this.subscription.typeSub == 'PF') {
                  this.$dialogs.alert("Dependentes alterados! Em até 2 minutos um CARNÊ de pagamento estará disponível.")
                } else if (this.subscription.paymentType == 'TICKET' && this.subscription.typeSub == 'PF') {
                  this.$dialogs.alert("Dependentes alterados! O valor referente a inclusão dos dependentes será cobrado em um boleto.")
                } else if (this.subscription.typeSub == 'PF') {
                  this.$dialogs.alert("Dependentes alterados! O valor referente a inclusão dos dependentes foi debitado do seu cartão.")
                } else if (this.subscription.typeSub == 'PF') {
                  this.$dialogs.alert("Dados registrados. Na próxima fatura haverá a cobrança pelos dependentes.")
                }
                this.addDependentForm.dependents = []

                this.loadSubscriptionData(this.selecionadaSubscription)
                this.loadDependentData(this.selecionadaSubscription)
              })
              .catch((error) => this.$dialogs.alert(error.response.data.msg, optionsAlert))
              .finally(() => {
                NProgress.done();
                this.addDependentForm.dependents = []; //clear
              });
          }
        })
    },
    openModalAddDependent() {
      this.$modal.show('modal-add-dependente');
    },
    closeModalAddDependent() {
      this.$modal.hide('modal-add-dependente');
    },
    openModalChangeDueDate() {
      this.$modal.show('modal-alterar-vencimento');
    },
    closeModalChangeDueDate() {
      this.$modal.hide('modal-alterar-vencimento');
    },
    openModalChangeCreditCard() {
      this.$modal.show('modal-cadastrar-cartao');
    },
    closeModalChangeCreditCard() {
      this.$modal.hide('modal-cadastrar-cartao');
    },
    openModalChangePaymentType() {
      this.$modal.show('modal-alterar-formapgt');
      this.changingPaymentType = true;
    },
    closeModalChangePaymentType() {
      this.$modal.hide('modal-alterar-formapgt');
    },
    loadLifes(idSubscription) {
      this.$clubApi.get('/subscription/' + idSubscription + '/list/group/lifes')
        .then(response => {
          this.lifes = response.data.object;
        }).catch(error => {
          this.$notify({ type: 'warning', message: error.response.data.msg })
        }).finally(() => {
          //NProgress.done();
        });
    },
    loadSubscriptionData(idSubscription) {
      this.loading = true;
      this.$clubApi.get('/subscription/load/' + idSubscription).then((response) => {
        this.subscription = response.data.object
        this.loadCreditCard();
      }).catch((error) => {
        this.$dialogs.alert(error.response.data.msg, optionsAlert)
      }).finally(() => {
        if (this.subscription.typeSub == 'PJ') {
          this.loadLifes(idSubscription)
        }
      })
    },
    generateFirstInvoice(idSubscription) {
      this.$clubApi.get('/subscription/invoice/first-generate/' + idSubscription)
        .then((response) => {
          this.$dialogs.alert("Atualização realizada com sucesso!", optionsAlert)
        }).finally(() => {
          NProgress.done()
        })
    },
    loadDependentData(idSubscription) {
      this.$clubApi.get('/subscription/list/dependent/' + idSubscription)
        .then((response) => {
          this.dependents = response.data.object
        }).catch((error) => {
          this.$dialogs.alert(error.response.data.msg, optionsAlert)
        }).finally(() => {
          //NProgress.done()
        })
    },
    loadCreditCard() {
      this.$clubApi.get(`/creditcard/subscription/${this.selecionadaSubscription}`)
        .then((response) => {
          this.creditcard = response.data.object;
          this.loading = false;
        }).finally(() => {
          NProgress.done()
        })
    },
    cancelDependent(dep) {
      const options = { title: 'Confirma cancelamento', okLabel: 'Sim', cancelLabel: 'Não' }
      this.$dialogs.confirm('Deseja realmente cancelar o dependente ' + dep.name + '?', options)
        .then(res => {
          if (res) {
            this.$clubApi.get('/subscription/remove/dependent/' + dep.id)
              .then(() => {
                if (this.subscription.paymentType == 'TICKETS') {
                  this.$dialogs.alert("Dependente cancelado! Em até 2 minutos um novo CARNÊ de pagamento estará disponível.", optionsAlert)
                } else {
                  this.$dialogs.alert("Dependente cancelado! Na próxima fatura não constará mais o mesmo.", optionsAlert)
                }
                this.loadSubscriptionData(this.selecionadaSubscription)
                this.loadDependentData(this.selecionadaSubscription)
              }).catch((error) => {
                this.$dialogs.alert(error.response.data.msg, optionsAlert)
              }).finally(() => {
                NProgress.done()
              })
          }
        })
    },
    updatePayDay() {
      this.closeModalChangeDueDate()
      const options = { title: 'Confirma alteração', okLabel: 'Sim', cancelLabel: 'Não' }
      this.$dialogs.confirm('Deseja realmente alterar o vencimento para TODO DIA ' + this.newpaymentday + '?', options)
        .then(res => {
          if (res.ok) {
            this.$clubApi.post('/subscription/update/payday', {
              newDay: this.newpaymentday,
              subscriptionId: this.subscription.id
            })
              .then(() => {
                if (this.subscription.paymentType == 'TICKETS') {
                  this.$dialogs.alert("Atualização realizada! Em até 2 minutos um novo CARNÊ de pagamento estará disponível.", optionsAlert)
                } else {
                  this.$dialogs.alert("Atualização realizada!", optionsAlert)
                }
                this.loadSubscriptionData()
              }).catch((error) => {
                this.$dialogs.alert(error.response.data.msg, optionsAlert)
              }).finally(() => {
                NProgress.done()
              })
          }
        })
    },
    preparePaymentType() {
      this.changingPaymentType = true;
      this.closeModalChangePaymentType();
      this.openModalChangeCreditCard();
    },
    updatePaymentType() {
      this.closeModalChangePaymentType();
      this.closeModalChangeCreditCard();
      const options = { title: 'Confirma alteração', okLabel: 'Sim', cancelLabel: 'Não' }
      this.$dialogs.confirm('Deseja realmente alterar a forma de pagamento?', options)
        .then(res => {
          if (res.ok) {
            this.$clubApi.post('/subscription/update/paymenttype', {
              newType: this.newpaymenttype,
              subscriptionId: this.subscription.id,
              card: this.newcreditcard
            })
              .then(() => {
                if (this.newpaymenttype == 'TICKETS') {
                  this.$dialogs.alert("Atualização realizada! Em até 2 minutos um CARNÊ de pagamento estará disponível.", optionsAlert)
                } else {
                  this.$dialogs.alert("Atualização realizada para os próximos pagamentos!", optionsAlert)
                }
                this.loadSubscriptionData();
                this.loadCreditCard();
                this.changingPaymentType = false;
              }).catch((error) => {
                this.$dialogs.alert(error.response.data.msg, optionsAlert);
              }).finally(() => {
                NProgress.done();
              })
          }
        })
    },
    async validateCreditCard(cardNumber) {
      try {
        const validationResponse = await this.$clubApi.post('/creditcard/validate', {
          firstSixDigits: cardNumber.replace(/\D/g, '').substring(0, 6),
          recaptchaResponse: await this.$recaptcha("creditcard")
        });

        if (validationResponse.data.object.prepaid) {
          this.$notify({
            type: 'warning',
            message: 'O cartão informado é pré-pago. Isso pode afetar futuras cobranças automáticas.'
          });
          return false;
        }
        return true;
      } catch (error) {
        this.$notify({ type: 'warning', message: 'Erro ao validar o cartão. Por favor, tente novamente.' });
        return false;
      }
    },
    async updateCreditCard() {
      if (this.changingPaymentType) {
        this.updatePaymentType();
        return false;
      }

      if (!/^\d{2}\/(\d{2}|\d{4})$/.test(this.newcreditcard.validate || '')) {
        this.$notify({ type: 'danger', message: 'Informe o vencimento no formato MM/AA ou MM/AAAA.' });
        return;
      }

      // normaliza MM/AA para MM/AAAA, formato que a API recebe
      const [mm, yy] = this.newcreditcard.validate.split('/');
      if (yy.length === 2) this.newcreditcard.validate = `${mm}/20${yy}`;

      const [month, year] = this.newcreditcard.validate.split('/').map(Number);
      const now = new Date();
      if (month < 1 || month > 12) {
        this.$notify({ type: 'danger', message: 'Mês de vencimento inválido.' });
        return;
      }
      // cartão vale até o último dia do mês de vencimento
      if (year * 12 + month < now.getFullYear() * 12 + now.getMonth() + 1) {
        this.$notify({ type: 'danger', message: 'O cartão informado está vencido.' });
        return;
      }

      this.closeModalChangeCreditCard();
      const options = { title: 'Confirma?', okLabel: 'Sim', cancelLabel: 'Não' };

      try {
        const res = await this.$dialogs.confirm('Deseja atualizar o seu cartão de crédito/débito?', options);
        if (!res.ok) return;

        const isValid = await this.validateCreditCard(this.newcreditcard.number);
        if (!isValid) return;

        this.newcreditcard.holderId = this.subscription.holder.id;
        this.newcreditcard.idSubscription = this.selecionadaSubscription;

        await this.$clubApi.post('/user/update/creditcard', this.newcreditcard);

        if (this.subscription.status === 'REQUESTED_CARD') {
          this.generateFirstInvoice(this.selecionadaSubscription);
        } else {
          await this.$dialogs.alert("Atualização realizada com sucesso!", optionsAlert);
          await this.$clubApi.post('/user/update/creditcardqueue/' + this.subscription.id);
        }

        this.loadCreditCard();
      } catch (error) {
        await this.$dialogs.alert(error.response.data.msg || 'Ocorreu um erro ao atualizar o cartão.', optionsAlert);
      } finally {
        NProgress.done();
      }
    },
    selecionarAssinatura(idSubscription) {
      this.selecionadaSubscription = (idSubscription === undefined) ? 0 : idSubscription;
      this.loadSubscriptionData(this.selecionadaSubscription);
      this.loadDependentData(this.selecionadaSubscription);
    },
  }
}
  </script>

  <style scoped>

</style>
